import { useSearchParams } from "react-router-dom";
import { calculatorList } from "./calculator.data";

export const Dashboard = () => {
  const [searchPrams] = useSearchParams();
  const lan = searchPrams.get("lan");
  return (
    <div
      className={`calculator-wrapper ${
        window.self === window.top ? "mt-5" : ""
      }`}
    >
      <div className="card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center py-2">
            <h2 className="card-title">
              {lan === "mr" ? "कैल्कुलेटर" : "Calculator"}
            </h2>
          </div>
        </div>
        <div className="card-body pt-4 pb-4">
          {calculatorList.map((item) => {
            if (lan === "mr" && (item.id === 4 || item.id === 5)) return null;
            return (
              <div className="calculator-selector mb-3" key={item.id}>
                <a
                  href={`${item?.link}${lan ? `?lan=${lan}` : ""}`}
                  className={`calculator-select-btn ${item?.backgroundColor}`}
                >
                  {item.name[lan || "en"]}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
